import {
    Button, Modal, ModalBody, ModalFooter,
} from 'appkit-react';

import FileExplorer from './FileExplorer';

const MoveFiles = ({
    visible, setVisible, onSave, fileExplorerDataSource, selection, setSelection,
    selectAll, setSelectAll, fetchFolderData, dirDetailsLoading,
    fileSelectionChangeHandler, fileExporerBreadcrumb, sameFolderError, loading,
}) => (
    <Modal
        visible={visible}
        onCancel={() => { setVisible(false); }}
        style={{ marginLeft: '-15rem', width: '65rem' }}
        backdropClosable={false}
    >
        <ModalBody style={{
            padding: 0, marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem',
        }}
        >

            <FileExplorer
                fileExplorerDataSource={fileExplorerDataSource}
                fetchFolderData={fetchFolderData}
                dirDetailsLoading={dirDetailsLoading}
                selection={selection}
                setSelection={setSelection}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                fileSelectionChangeHandler={fileSelectionChangeHandler}
                fileExporerBreadcrumb={fileExporerBreadcrumb}
            />

            {/* <div>Move files</div> */}
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'flex-end' }}>
            {sameFolderError && <span style={{ marginRight: '1rem', color: 'red' }}>You are in same folder.</span>}
            <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> CANCEL </Button>
            <Button kind="primary" size="lg" onClick={onSave} disabled={dirDetailsLoading} isLoading={loading}> MOVE HERE </Button>
        </ModalFooter>
    </Modal>
);

export default MoveFiles;
